<template>
  <Teleport :to="target">
    <div v-show="show" class="overlay"  ref="refModal" v-bind="$attrs">
      <slot></slot>
    </div>
  </Teleport>
</template>
<script setup>
import { defineProps, defineEmits, nextTick, watch, ref } from "vue";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import { useStore } from "vuex";
const { commit } = useStore();
const props = defineProps({
  target: {
    type: String,
    default: "body",
  },
  show: {
    type: Boolean,
    default: false,
  },
});

const refModal = ref();
const { activate, deactivate } = useFocusTrap(refModal);
watch(
  () => props.show,
  (val) => {
    if (val) {
      commit("businessModule/increaseModalCount");
      nextTick(() => {
        if (
          !!refModal.value.querySelector(
            'a[href], button, input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])'
          )
        ) {
          activate();
        }
      });
    } else {
      commit("businessModule/decreaseModalCount");
      deactivate();
    }
  },
  {
    immediate: true,
  }
);

const emit = defineEmits("update:show");
</script>
